"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("../styles");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var UploadFile = function UploadFile(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor,
    _ref$animation = _ref.animation,
    animation = _ref$animation === void 0 ? '' : _ref$animation;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/_react["default"].createElement(_styles.Svg, {
    className: "".concat(className, " ").concat(animation),
    width: size,
    height: size,
    viewBox: "0 0 81 80",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M64.79 25.584v36.73a7.707 7.707 0 0 1-7.707 7.706H24.622a7.707 7.707 0 0 1-7.707-7.707V17.121a7.692 7.692 0 0 1 7.707-7.707h24.412l15.755 16.17ZM27.182 59.045h27.315"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M49.034 9.414V19.56a6.021 6.021 0 0 0 6.024 6.024h9.731L49.034 9.414ZM40.84 29.633v20.315M31.133 39.68l9.707-10.194 9.731 10.195"
  })), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#fff",
    d: "M15.5 8h50.679v63.434H15.5z"
  }))));
};
var _default = exports["default"] = UploadFile;